import React, { FC } from 'react';
import { liveStreamStatusNames } from '../../../constans/presenter-constansts';
import { LiveStreamStatus } from '../../../constans/presenter-enums';

interface IProps {
  status: LiveStreamStatus;
}

const LiveStreamStatusComponent: FC<IProps> = (props) => {
  const liveStatusName = liveStreamStatusNames[props.status];
  const liveStatusIconClassName = `live-stream-status-icon ${liveStatusName?.toLocaleLowerCase()}`;

  return (
    <div className='live-stream-status'>
      <span className='live-stream-status-name'>{liveStatusName}</span>
      <span className={liveStatusIconClassName}/>
    </div>
  );
};

export { LiveStreamStatusComponent };
